import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/landing/landing/node_modules/next/dist/client/app-dir/link.js");
